var _a;
import { __awaiter, __generator } from "tslib";
import { AdaptiveCardEventOriginator } from '@office-start/adaptive-card-types';
import { getAppHostAdaptiveCardEventHandler } from './getAppHostAdaptiveCardEventHandler';
var novaEventMap = (_a = {},
    _a[AdaptiveCardEventOriginator] = getAppHostAdaptiveCardEventHandler,
    _a);
export var useAppHostAdaptiveCardNovaEventHandler = function () {
    return {
        bubble: function (event) {
            return __awaiter(this, void 0, void 0, function () {
                var novaEvent;
                return __generator(this, function (_a) {
                    if (novaEventMap[event.event.originator]) {
                        novaEvent = novaEventMap[event.event.originator](event);
                        return [2 /*return*/, novaEvent];
                    }
                    else {
                        throw new Error("No such ".concat(event.event.originator, " event exist"));
                    }
                    return [2 /*return*/];
                });
            });
        },
    };
};
//# sourceMappingURL=useAppHostAdaptiveCardNovaEventHandler.js.map